import {useContext, useEffect} from "react";
import {useParams} from "react-router-dom";
import {useQuery} from "@tanstack/react-query";
import {getProductsByCodePrefix} from "../../api/catalog";
import {ReducerStateInterface} from "../../interfaces/core/ReducerStateInterface";
import {GlobalContext, ReducerActionType} from "../../GlobalReducer";
import CatelogBase from "./CatalogBase";

export default function CatalogByCodePrefix() {
    const {codePrefix} = useParams<{codePrefix: string}>();
    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);

    const {data: response, status} = useQuery({
        queryKey: ['by-code-prefix', codePrefix, state.customer?.id],
        queryFn: () => getProductsByCodePrefix(codePrefix as string, state.customer),
        enabled: !!codePrefix,
        //@ts-ignore
        retry: !window.NOSCRIPT ? false : 1,
    });

    useEffect(() => {
        switch (status) {
            case 'pending':
                dispatch({type: ReducerActionType.LOAD});
                return;
            case 'error':
                dispatch({type: ReducerActionType.ERROR, payload: 'При загрузке товаров возникли ошибки'});
                return;
            case 'success':
                dispatch({type: ReducerActionType.SUCCESS});
                return;
        }
    }, [status]);

    useEffect(() => {
        dispatch({type: ReducerActionType.SET_BREADCRUMBS, payload: [{name: 'Результаты поиска'}]});
    }, [codePrefix]);

    return (<>{response && <CatelogBase response={response} header={'Результаты поиска'} baseUrl={'/catalog/by-code/' + codePrefix} />}</>);
}
